import { request } from '../until/axios.js'


export function getlogin(loginForm) {
  return request({
    url: 'index.php/manager/login/index',
    method: 'post',
    data: loginForm
  })

}
export function getInfo() {
  return request({
    url: 'index.php/manager/users/userinfo',
    method: 'post',
    data: {}
  })
}
export function editpsd() {
  return request({
    url: 'index.php/manager/users/editpsd',
    method: 'post',
    data: {}
  })
}

// 教师
export function teacher_list(data) {
  return request({
    url: 'index.php/manager/Teacher/teacher_list',
    method: 'get',
    params: data
  })
}
export function edit_teacher(data) {
  return request({
    url: 'index.php/manager/Teacher/edit_teacher',
    method: 'post',
    data: data
  })
}
export function teacher_details(data) {
  return request({
    url: 'index.php/manager/Teacher/teacher_details',
    method: 'get',
    params: data
  })
}
export function add_teacher(data) {
  return request({
    url: 'index.php/manager/Teacher/add_teacher',
    method: 'post',
    data: data
  })
}
export function bact_delete_teacher(data) {
  return request({
    url: 'index.php/manager/Teacher/bact_delete_teacher',
    method: 'post',
    data: data
  })
}
export function dodaoru(data) {
  return request({
    url: 'index.php/manager/Teacher/dodaoru',
    method: 'post',
    data: data
  })
}
// 学生
export function add_student(data) {
  return request({
    url: 'index.php/manager/Student/add_student',
    method: 'post',
    data: data
  })
}
export function student_details(data) {
  return request({
    url: 'index.php/manager/Student/student_details',
   method: 'get',
   params: data
  })
}
export function edit_student(data) {
  return request({
    url: 'index.php/manager/Student/edit_student',
    method: 'post',
    data: data
  })
}
export function student_list(data) {
  return request({
    url: 'index.php/manager/Student/student_list',
    method: 'get',
    params: data
  })
}
export function bact_delete_student(data) {
  return request({
    url: 'index.php/manager/Student/bact_delete_student',
    method: 'post',
    data: data
  })
}
export function student_add_banji(data) {
  return request({
    url: 'index.php/manager/Student/student_add_banji',
    method: 'post',
    data: data
  })
}
export function bact_delete_student_ban(data) {
  return request({
    url: 'index.php/manager/Banji/bact_delete_student',
    method: 'post',
    data: data
  })
}
// 院系
export function add_department(data) {
  return request({
    url: 'index.php/manager/index/add_department',
    method: 'post',
    data: data
  })
}
export function department_details(data) {
  return request({
    url: 'index.php/manager/index/department_details',
   method: 'get',
   params: data
  })
}
export function edit_department(data) {
  return request({
    url: 'index.php/manager/index/edit_department',
    method: 'post',
    data: data
  })
}
export function department_list(data) {
  return request({
    url: 'index.php/manager/index/department_list',
    method: 'get',
    params: data
  })
}
export function bact_delete_department(data) {
  return request({
    url: 'index.php/manager/index/bact_delete_department',
    method: 'post',
    data: data
  })
}
// 班级
export function add_banji(data) {
  return request({
    url: 'index.php/manager/banji/add_banji',
    method: 'post',
    data: data
  })
}
export function banji_details(data) {
  return request({
    url: 'index.php/manager/banji/banji_details',
   method: 'get',
   params: data
  })
}
export function edit_banji(data) {
  return request({
    url: 'index.php/manager/banji/edit_banji',
    method: 'post',
    data: data
  })
}
export function banji_list(data) {
  return request({
    url: 'index.php/manager/banji/banji_list',
    method: 'get',
    params: data
  })
}
export function bact_delete_banji(data) {
  return request({
    url: 'index.php/manager/banji/bact_delete_banji',
    method: 'post',
    data: data
  })
}
// 课程
export function kecheng_list(data) {
  return request({
    url: 'index.php/manager/kecheng/kecheng_list',
   method: 'get',
   params: data
  })
}
// 课程
export function teacherkecheng_list(data) {
  return request({
    url: 'index.php/manager/teacher/kecheng_list',
   method: 'get',
   params: data
  })
}
export function add_kecheng_banji(data) {
  return request({
    url: 'index.php/manager/teacher/add_kecheng_banji',
    method: 'post',
    data: data
  })
}
export function delete_kecheng_banji(data) {
  return request({
    url: 'index.php/manager/teacher/delete_kecheng_banji',
    method: 'post',
    data: data
  })
}
export function add_kecheng_banji1(data) {
  return request({
    url: 'index.php/manager/Kecheng/add_kecheng_banji',
    method: 'post',
    data: data
  })
}
export function delete_kecheng_banji1(data) {
  return request({
    url: 'index.php/manager/Kecheng/delete_kecheng_banji',
    method: 'post',
    data: data
  })
}


export function bact_delete_kecheng(data) {
  return request({
    url: 'index.php/manager/kecheng/bact_delete_kecheng',
    method: 'post',
    data: data
  })
}
export function kecheng_details(data) {
  return request({
    url: 'index.php/manager/kecheng/kecheng_details',
   method: 'get',
   params: data
  })
}
export function add_kecheng(data) {
  return request({
    url: 'index.php/manager/kecheng/add_kecheng',
    method: 'post',
    data: data
  })
}
export function edit_kecheng(data) {
  return request({
    url: 'index.php/manager/kecheng/edit_kecheng',
    method: 'post',
    data: data
  })
}
export function kecheng_banji_add(data) {
  return request({
    url: 'index.php/manager/kecheng/kecheng_banji_add',
    method: 'post',
    data: data
  })
}
export function kecheng_banji_delete(data) {
  return request({
    url: 'index.php/manager/kecheng/kecheng_banji_delete',
    method: 'post',
    data: data
  })
}
export function student_banji_xuesheng_list(data) {
  return request({
    url: 'index.php/manager/banji/student_banji_xuesheng_list',
   method: 'get',
   params: data
  })
}
export function no_student_banji_xuesheng_list(data) {
  return request({
    url: 'index.php/manager/banji/no_student_banji_xuesheng_list',
   method: 'get',
   params: data
  })
}
export function kecheng_banji(data) {
  return request({
    url: 'index.php/manager/kecheng/kecheng_banji',
   method: 'get',
   params: data
  })
}
// 章节
export function mulu(data) {
  return request({
    url: 'index.php/manager/kecheng/mulu',
   method: 'get',
   params: data
  })
}
export function jie_details(data) {
  return request({
    url: 'index.php/manager/kecheng/jie_details',
   method: 'get',
   params: data
  })
}
export function add_zhang(data) {
  return request({
    url: 'index.php/manager/kecheng/add_zhang',
    method: 'post',
    data: data
  })
}
export function edit_zhang(data) {
  return request({
    url: 'index.php/manager/kecheng/edit_zhang',
    method: 'post',
    data: data
  })
}
export function delete_zhang(data) {
  return request({
    url: 'index.php/manager/kecheng/delete_zhang',
   method: 'get',
   params: data
  })
}

export function add_jie(data) {
  return request({
    url: 'index.php/manager/kecheng/add_jie',
    method: 'post',
    data: data
  })
}
export function edit_jie(data) {
  return request({
    url: 'index.php/manager/kecheng/edit_jie',
    method: 'post',
    data: data
  })
}
export function delete_jie(data) {
  return request({
    url: 'index.php/manager/kecheng/delete_jie',
   method: 'get',
   params: data
  })
}
export function kejianlist(data) {
  return request({
    url: 'index.php/manager/kecheng/kejianlist',
   method: 'get',
   params: data
  })
}
export function add_jie_kejian(data) {
  return request({
    url: 'index.php/manager/kecheng/add_jie_kejian',
    method: 'post',
    data: data
  })
}
export function deletekejian(data) {
  return request({
    url: 'index.php/manager/kecheng/deletekejian',
    method: 'post',
    data: data
  })
}
// 实训任务
export function renwu_details(data) {
  return request({
    url: 'index.php/manager/Renwu/renwu_details',
   method: 'get',
   params: data
  })
}
export function add_renwu(data) {
  return request({
    url: 'index.php/manager/Renwu/add_renwu',
    method: 'post',
    data: data
  })
}
export function edit_renwu(data) {
  return request({
    url: 'index.php/manager/Renwu/edit_renwu',
    method: 'post',
    data: data
  })
}
export function delete_renwu(data) {
  return request({
    url: 'index.php/manager/Renwu/delete_renwu',
    method: 'post',
    data: data
  })
}
//章节试题
export function select_kecheng_zhang_jie_question(data) {
  return request({
    url: 'index.php/manager/kecheng/select_kecheng_zhang_jie_question',
   method: 'get',
   params: data
  })
}
export function add_kecheng_zhang_jie_question(data) {
  return request({
    url: 'index.php/manager/kecheng/add_kecheng_zhang_jie_question',
    method: 'post',
    data: data
  })
}
export function delete_kecheng_question(data) {
  return request({
    url: 'index.php/manager/kecheng/delete_kecheng_question',
    method: 'post',
    data: data
  })
}
export function kecheng_zhang_jie_question_list(data) {
  return request({
    url: 'index.php/manager/kecheng/kecheng_zhang_jie_question_list',
    method: 'post',
    data: data
  })
}

// 作业
export function task_list(data) {
  return request({
    url: 'index.php/manager/task/task_list',
   method: 'get',
   params: data
  })
}
export function bact_delete_task(data) {
  return request({
    url: 'index.php/manager/task/bact_delete_task',
    method: 'post',
    data: data
  })
}
export function task_status(data) {
  return request({
    url: 'index.php/manager/task/task_status',
    method: 'post',
    data: data
  })
}
export function task_details(data) {
  return request({
    url: 'index.php/manager/task/task_details',
   method: 'get',
   params: data
  })
}
export function add_task(data) {
  return request({
    url: 'index.php/manager/task/add_task',
    method: 'post',
    data: data
  })
}
export function edit_task(data) {
  return request({
    url: 'index.php/manager/task/edit_task',
    method: 'post',
    data: data
  })
}
//作业试题
export function task_question_list(data) {
  return request({
    url: 'index.php/manager/task/task_question_list',
   method: 'get',
   params: data
  })
}
export function select_task_question(data) {
  return request({
    url: 'index.php/manager/task/select_task_question',
   method: 'get',
   params: data
  })
}
export function add_task_question(data) {
  return request({
    url: 'index.php/manager/task/add_task_question',
    method: 'post',
    data: data
  })
}
export function delete_task_quest(data) {
  return request({
    url: 'index.php/manager/task/delete_task_quest',
    method: 'post',
    data: data
  })
}
export function submit_task_student_list(data) {
  return request({
    url: 'index.php/manager/task/submit_task_student_list',
   method: 'get',
   params: data
  })
}
export function task_question_details(data) {
  return request({
    url: 'index.php/manager/task/task_question_details',
   method: 'get',
   params: data
  })
}
// 题库
export function question_list(data) {
  return request({
    url: 'index.php/manager/question/question_list',
   method: 'get',
   params: data
  })
}
export function bact_delete_question(data) {
  return request({
    url: 'index.php/manager/question/bact_delete_question',
    method: 'post',
    data: data
  })
}
export function add_question(data) {
  return request({
    url: 'index.php/manager/question/add_question',
    method: 'post',
    data: data
  })
}
export function add_yingyong_question(data) {
  return request({
    url: 'index.php/manager/question/add_yingyong_question',
    method: 'post',
    data: data
  })
}
export function question_details(data) {
  return request({
    url: 'index.php/manager/question/question_details',
   method: 'get',
   params: data
  })
}
export function edit_question(data) {
  return request({
    url: 'index.php/manager/question/edit_question',
    method: 'post',
    data: data
  })
}
export function edit_yingyong_question(data) {
  return request({
    url: 'index.php/manager/question/edit_yingyong_question',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/new.js